import React from 'react';
import { useNavigate } from 'react-router-dom';
import { DocumentCenter } from '../components/DocumentCenter';
import { BottomNavigation } from '../components/BottomNavigation';
import { BackButton } from '../components/ui';

export default function Documents() {
  const navigate = useNavigate();

  const handleBack = () => {
    // Try to go back to previous page, fallback to seller-hub
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/seller-hub');
    }
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      background: '#F9F9F9',
      paddingBottom: '120px'
    }}>
      {/* Header */}
      <div style={{
        background: '#FFF',
        padding: '20px',
        borderBottom: '1px solid #E0E0E0',
        marginBottom: '20px'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '16px',
          marginBottom: '16px'
        }}>
          <BackButton
            onClick={handleBack}
            variant="standard"
            ariaLabel="Go back"
          />
          <h1 style={{
            fontSize: 24,
            fontWeight: 700,
            color: '#222',
            margin: 0,
            fontFamily: 'Sora, sans-serif'
          }}>
            Documents Center
          </h1>
        </div>
        <p style={{
          fontSize: 16,
          color: '#757575',
          margin: '0 0 0 40px',
          fontFamily: 'Montserrat, sans-serif'
        }}>
          Manage your compliance documents and certifications
        </p>
      </div>

      {/* Main Content */}
      <div style={{ padding: '0 20px' }}>
        <DocumentCenter />
      </div>

      {/* Bottom Navigation */}
      <BottomNavigation />
    </div>
  );
}
